import React, { useContext, useEffect } from 'react';
import { RouteContext } from './ApplicationStateful';
import { toArray } from '../../utils/ArrayUtils';
import { matchPath, Route, Routes, useLocation } from 'react-router';

/**
 * React router dom Switch wrapper to store defined routes with path and name to context.
 * This enables us to define route inside a switch without use of separate code-list of route properties.
 * @param props
 * @returns {*}
 * @constructor
 */
export const RouterSwitch = function (props) {
	const [, setRoutes] = useContext(RouteContext);
	const { pathname } = useLocation();

	useEffect(() => {
		const parseRoute = (routes, item, parentPath) => {
			if (
				item &&
				item.type === Route &&
				item.props.path &&
				item.props.path !== '*'
			) {
				const fullPath = parentPath
					? (parentPath === '/' ? '' : parentPath) + '/' + item.props.path
					: item.props.path;
				routes.push({
					path: item.props.path,
					fullPath: fullPath,
					name: item.props.name,
					end: item.props.end === true,
					resolver: item.props.resolver,
					children: toArray(item.props.children).reduce(
						(childRoutes, child) => parseRoute(childRoutes, child, fullPath),
						[]
					),
				});
			}
			return routes;
		};

		const traceBreadcrumb = (routes, breadcrumbs) => {
			const filteredList = routes.filter((currentObj, index, arr) => {
				const hasChildren = currentObj.children.length > 0;
				const isDuplicateName =
					arr.findIndex(
						(obj) => obj.path === currentObj.path && obj !== currentObj
					) !== -1;
				const isRoot = currentObj.path === '/';
				return !isRoot && (!isDuplicateName || hasChildren);
			});
			const item = filteredList.find(
				(route) => !!matchPath({ path: route.fullPath, end: false }, pathname)
			);

			if (item) {
				breadcrumbs.push(item);
				traceBreadcrumb(item.children, breadcrumbs);
			}
			return breadcrumbs;
		};

		const routes = props.children.reduce(
			(routes, item) => parseRoute(routes, item, undefined),
			[]
		);
		const breadcrumbs = traceBreadcrumb(routes, []);

		setRoutes({
			routes: routes,
			breadcrumbs: breadcrumbs,
		});
	}, [pathname]);

	return <Routes>{props.children}</Routes>;
};
